import { RealEstateDataPageComponentData } from 'types'
import React from 'react'
import { navigate } from 'gatsby'
import useQuerySummary from '@hooks/useQuerySummary'
import { reduxUpdateFilters } from '@slices/propertiesSlice'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { ElementHTML } from '@helpers/helper.rendering'
import { useGetAdvancedLocationsQuery } from '@apis/middlewareTokkoApi/properties'
import { getChildrens, getFathers, getGrandfathers } from '@helpers/helper.filters'

interface Filter {
  type: string
  value: string
  id: number
  item?: any
}

const SeoComponent = ({
  global_data,
  spanText,
  titleElement,
  titleColor,
  titleHexa,
  is_short,
}: RealEstateDataPageComponentData) => {
  const { allSummaryData, isLoading } = useQuerySummary({
    API_KEY: global_data.pageConfig.keys.tokko,
  })

  const dispatch = useDispatch()

  const OPERATION = !spanText
    ? ['', 'Venta', 'Alquier', 'Temporario']
    : [spanText, spanText, spanText, spanText]

  const { allSummaryData: summaryByOperation } = useQuerySummary({
    API_KEY: global_data.pageConfig.keys.tokko,
    OPERATION: OPERATION[getMainOperation()],
  })

  const { data: advancedLocationsData, isLoading: isLoadingadvancedLocations } =
    useGetAdvancedLocationsQuery({
      API_KEY: global_data.pageConfig.keys.tokko,
      operation: OPERATION[getMainOperation()],
    })

  function getMainOperation() {
    if (allSummaryData?.objects?.operation_types) {
      const operations = allSummaryData?.objects?.operation_types?.map(
        (operation: any) => operation,
      )
      return (
        operations.sort((a: { count: number }, b: { count: number }) => b.count - a.count).at(0)
          ?.operation_type || undefined
      )
    }
  }

  const PillElement = ({ value, type, id, item }: Filter) => {
    const refillFilterByType = ({ value, type, id }: Filter) => {
      if (type === 'environments') {
        return { environments: `${id}-${id}` }
      }
      return { [type]: [{ id, name: value }] }
    }

    if (type === 'location-father') {
      return (
        <div
          onClick={() => {
            navigate(
              '/' +
                OPERATION[getMainOperation()].toLowerCase() +
                '/' +
                value
                  ?.normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
                  .replaceAll(' ', '-'),
            )
            updateByParent(item)
          }}
          className="pill_seo btn mb-3 me-3 btn-primary border"
        >
          {value}
        </div>
      )
    }

    return (
      <div
        onClick={() => {
          navigate(
            '/' +
              OPERATION[getMainOperation()].toLowerCase() +
              '/' +
              value
                ?.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .replaceAll(' ', '-'),
          )
          dispatch(
            reduxUpdateFilters({ ...ReFillFilters(), ...refillFilterByType({ type, value, id }) }),
          )
        }}
        className="pill_seo btn mb-3 me-3 btn-primary border"
      >
        {value}
      </div>
    )
  }

  const ReFillFilters = () => {
    return {
      location: [],
      type: [],
      operation: OPERATION[getMainOperation()],
      environments: '',
      bedrooms: '',
      age: '',
      address: '',
      producer_id: '',
      price: {
        type: '',
        priceMin: '',
        priceMax: '',
        is_off: false,
      },
      surface: {
        type: '',
        surfaceMin: '',
        surfaceMax: '',
      },
      environments_types: [],
      generals: [],
      services: [],
      specials: [],
    }
  }

  function validateLocation(name_loc: string) {
    const gfs = getGrandfathers(advancedLocationsData)
    for (const gf of gfs) {
      const fts = getFathers(gf)
      for (const ft of fts) {
        const name = ft[0]
        if (name_loc == name) {
          return false
        }
      }
    }
    return true
  }

  function updateByParent(item: any) {
    const childrens: any = getChildrens(item)
    console.log(childrens)
    let newLocations: any[] = []
    if (childrens.length > 0) {
      for (const children of childrens) {
        console.log(children)
        newLocations = newLocations.filter((element) => element.id !== children[1]?.id)
        newLocations.push({ id: children[1]?.id, name: children[0] })
      }
      dispatch(reduxUpdateFilters({ ...ReFillFilters(), location: newLocations }))
    } else {
      dispatch(
        reduxUpdateFilters({ ...ReFillFilters(), location: [{ id: item[1].id, name: item[0] }] }),
      )
    }
  }

  return !isLoading && summaryByOperation?.objects.locations.length === 0 ? null : (
    <section className={'p-y-config seo-component a ' + titleColor}>
      <Container fluid>
        <div className="section">
          <ElementHTML
            elementType={titleElement || 'h5'}
            className={'title ' + (titleColor || '')}
            style={{ color: titleHexa }}
            children={`Propiedades en ${OPERATION[getMainOperation()]} por ubicación`}
          />
          <Row>
            <Col lg={9}>
              {is_short ? (
                advancedLocationsData?.objects
                  .slice(0, 20)
                  .map(
                    ({
                      location_name,
                      location_id,
                    }: {
                      location_name: string
                      location_id: number
                    }) => (
                      <PillElement
                        key={location_id}
                        type={'location'}
                        id={location_id}
                        value={location_name}
                      />
                    ),
                  )
              ) : (
                <div>
                  {advancedLocationsData?.locations
                    ? getGrandfathers(advancedLocationsData).map((gf) =>
                        // <div>{console.log(gf)}</div>
                        getFathers(gf).map((ft: any) => (
                          <PillElement
                            key={ft[0]}
                            item={ft}
                            type={'location-father'}
                            id={ft[0]?.id}
                            value={ft[0]}
                          />
                        )),
                      )
                    : ''}
                </div>
              )}
            </Col>
          </Row>
        </div>
        <div className="section">
          <ElementHTML
            elementType={titleElement || 'h5'}
            className={'title ' + (titleColor || '')}
            style={{ color: titleHexa }}
            children={`Propiedades en ${OPERATION[getMainOperation()]}`}
          />
          <Row>
            <Col lg={9}>
              {summaryByOperation?.objects.property_types
                .slice(0, 20)
                .map(({ type, id }: { type: string; id: number }) => (
                  <PillElement
                    key={id}
                    type={'type'}
                    id={id}
                    value={type}
                  />
                ))}
            </Col>
          </Row>
        </div>
        <div className="section">
          <ElementHTML
            elementType={titleElement || 'h5'}
            className={'title ' + (titleColor || '')}
            style={{ color: titleHexa }}
            children={`Propiedades en ${OPERATION[getMainOperation()]} por ambientes`}
          />
          <Row>
            <Col lg={9}>
              {summaryByOperation?.objects.room_amount.map(
                ({ amount }: { amount: number }) =>
                  amount !== 0 && (
                    <PillElement
                      key={amount}
                      type="environments"
                      value={amount.toString() + ' Ambiente' + (amount == 1 ? '' : 's')}
                      id={amount}
                    />
                  ),
              )}
            </Col>
          </Row>
        </div>
        <div className="section">
          <ElementHTML
            elementType={titleElement || 'h5'}
            className={'title ' + (titleColor || '')}
            style={{ color: titleHexa }}
            children={`Propiedades en ${OPERATION[getMainOperation()]} por tipo de ambientes`}
          />
          <Row>
            <Col lg={9}>
              {summaryByOperation?.objects.tags.map(
                ({
                  tag_type,
                  tag_name,
                  tag_id,
                }: {
                  tag_id: number
                  tag_type: number
                  tag_name: string
                }) =>
                  tag_type === 2 && (
                    <PillElement
                      key={tag_id}
                      type="environments_types"
                      id={tag_id}
                      value={tag_name}
                    />
                  ),
              )}
            </Col>
          </Row>
        </div>
        <div className="section">
          <ElementHTML
            elementType={titleElement || 'h5'}
            className={'title ' + (titleColor || '')}
            style={{ color: titleHexa }}
            children={`Propiedades en ${OPERATION[getMainOperation()]} por servicios`}
          />
          <Row>
            <Col lg={9}>
              {summaryByOperation?.objects.tags.map(
                ({
                  tag_type,
                  tag_name,
                  tag_id,
                }: {
                  tag_id: number
                  tag_type: number
                  tag_name: string
                }) =>
                  tag_type === 3 && (
                    <PillElement
                      key={tag_id}
                      type="services"
                      id={tag_id}
                      value={tag_name}
                    />
                  ),
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  )
}

export default SeoComponent
